"use client"

import { motion } from "framer-motion";
import { Clock, ListChecks, Microscope, RadioTower } from "lucide-react";
import { Products } from "@/types/productsTypes";

const stageIconMap = {
    ingest: RadioTower,
    triage: Microscope,
    investigate: ListChecks,
    respond: Clock,
} as const;

export function Automation({ section }: { section: Products["atlasai"]["automation"] }) {
    return (
        <section className="section-primary">
            <div className="max-w-6xl mx-auto space-y-10">
                <div className="text-center space-y-4">
                    <span className="section-badge badge-size inline-block w-fit">
                        {section.badge}
                    </span>
                    <h2 className="title-size font-semibold text-bg">
                        {section.title}
                    </h2>
                    <p className="text-size text-muted-foreground max-w-3xl mx-auto">
                        {section.description}
                    </p>
                </div>

                <div className="grid gap-6 md:grid-cols-2">
                    {section.stages.map((stage, index) => {
                        const Icon = stageIconMap[stage.name as keyof typeof stageIconMap] || Microscope;
                        return (
                            <motion.div
                                key={stage.name}
                                initial={{ opacity: 0, y: 25 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                className="rounded-3xl border bg-white p-6 shadow-sm"
                            >
                                <div className="flex items-start gap-3">
                                    <div className="iconBudg size-10">
                                        <Icon className="size-5" />
                                    </div>
                                    <div className="space-y-2">
                                        <h3 className="text-lg font-semibold text-bg">
                                            {stage.summary}
                                        </h3>
                                        <ul className="space-y-2 text-sm text-muted-foreground">
                                            {stage.details.map((item) => (
                                                <li key={item} className="flex items-start gap-2">
                                                    <span className="mt-1 size-2 rounded-full bg-secondary-500" />
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
